// About this file:
// The groups are at the moment hard coded but should be implemented later as a
// table with group definitions and a relational table.
// For the moment, I recommend copying rows from crm-user-list.js when adding
// users to specific groups.

const boras = {
    id: 'boras',
    name: 'BORÅS',
    users: [],
};

const gavle = {
    id: 'gavle',
    name: 'GÄVLE',
    users: [{ id: '00ACCEC0-0000-0000-0000-000000000000', name: 'Daniel Theorin' }],
};

const jkpg = {
    id: 'jkpg',
    name: 'JKPG',
    users: [
        { id: '00B7B745-0000-0000-0000-000000000000', name: 'Ernad Muratagic' },
        { id: '00ACAD88-0000-0000-0000-000000000000', name: 'Katarina Stekovic' },
        { id: '00AD845C-0000-0000-0000-000000000000', name: 'Oskar Sjöman' },
        { id: '00AD79AC-0000-0000-0000-000000000000', name: 'Tove Abelson' },
        { id: '00AD79B0-0000-0000-0000-000000000000', name: 'Tobias Sandqvist' },
    ],
};

const karlskrona = {
    id: 'karlskrona',
    name: 'KARLSKRONA',
    users: [{ id: '00AD5BEE-0000-0000-0000-000000000000', name: 'Jack Eriksson' }],
};

const mitt = {
    id: 'mitt',
    name: 'MITT',
    users: [
        { id: '00ADE474-0000-0000-0000-000000000000', name: 'Anders Lundberg' },
        { id: '00ADBD22-0000-0000-0000-000000000000', name: 'Andreas Claesson' },
        { id: '00AE9E92-0000-0000-0000-000000000000', name: 'Christoffer Nilsson' },
        { id: '00B68A40-0000-0000-0000-000000000000', name: 'Claes Gustafsson' },
        { id: '00ADBD26-0000-0000-0000-000000000000', name: 'David Norén' },
        { id: '00B68A43-0000-0000-0000-000000000000', name: 'Erica Damgaard' },
        { id: '00B7FB4F-0000-0000-0000-000000000000', name: 'Isabella Ström' },
        { id: '00ACAD7E-0000-0000-0000-000000000000', name: 'Johan Rigbrant' },
        { id: '00ADBD3A-0000-0000-0000-000000000000', name: 'Lars Hermansson' },
        { id: '00ADBD3C-0000-0000-0000-000000000000', name: 'Linnea Karlsson' },
        { id: '00ADBD38-0000-0000-0000-000000000000', name: 'Victor Caldemar' },
        { id: '00CD02E0-0000-0000-0000-000000000000', name: 'Carl Olsson' },
        { id: '00D79C9C-0000-0000-0000-000000000000', name: 'Louise Hulterström' },
    ],
};

const mitt_new_business = {
    id: 'mitt_new_business',
    name: 'MITT - New Business',
    users: [
        { id: '00B68A40-0000-0000-0000-000000000000', name: 'Claes Gustafsson' },
        { id: '00ADBD26-0000-0000-0000-000000000000', name: 'David Norén' },
        { id: '00B68A43-0000-0000-0000-000000000000', name: 'Erica Damgaard' },
        { id: '00B7FB4F-0000-0000-0000-000000000000', name: 'Isabella Ström' },
        { id: '00ADBD38-0000-0000-0000-000000000000', name: 'Victor Caldemar' },
    ],
};

const sthlm = {
    id: 'sthlm',
    name: 'STHLM',
    users: [
        { id: '00B6441A-0000-0000-0000-000000000000', name: 'Camjar Djoweini' },
        { id: '00ACC388-0000-0000-0000-000000000000', name: 'Claes Friberg' },
        { id: '00AAB501-0000-0000-0000-000000000000', name: 'Daniel Henriksson' },
        { id: '00ACB5FC-0000-0000-0000-000000000000', name: 'Jacob Rudin' },
        { id: '00AE5708-0000-0000-0000-000000000000', name: 'Johanna Torstensson' },
        { id: '00ACCEBC-0000-0000-0000-000000000000', name: 'Jonas Backman' },
        { id: '00B0397A-0000-0000-0000-000000000000', name: 'Kalle Hultman' },
        { id: '00ACB5AA-0000-0000-0000-000000000000', name: 'Karl Altenstam' },
        { id: '00AE570A-0000-0000-0000-000000000000', name: 'Klara Hellman' },
        { id: '00ACB652-0000-0000-0000-000000000000', name: 'Madeléne Gardbeck' },
        { id: '00ACB732-0000-0000-0000-000000000000', name: 'Mattias Danielsson' },
        { id: '00ACC2F4-0000-0000-0000-000000000000', name: 'Mirza Kozica' },
        { id: '00ACB9A6-0000-0000-0000-000000000000', name: 'Paula Wallner' },
        { id: '00B64414-0000-0000-0000-000000000000', name: 'Rebecca Nilsson' },
        { id: '00ACB712-0000-0000-0000-000000000000', name: 'Simon Jansson' },
        { id: '00B64417-0000-0000-0000-000000000000', name: 'Sofia Rosqvist' },
        { id: '00B81BA1-0000-0000-0000-000000000000', name: 'Anders Camper' },
        { id: '00C12436-0000-0000-0000-000000000000', name: 'Thomas Sundtoft' },
        { id: '00CABCE8-0000-0000-0000-000000000000', name: 'Julia Wolf' },
    ],
};

const sthlm_private = {
    id: 'sthlm_private',
    name: 'STHLM - Private',
    users: [
        { id: '00B6441A-0000-0000-0000-000000000000', name: 'Camjar Djoweini' },
        { id: '00ACB5FC-0000-0000-0000-000000000000', name: 'Jacob Rudin' },
        { id: '00AE5708-0000-0000-0000-000000000000', name: 'Johanna Torstensson' },
        { id: '00ACCEBC-0000-0000-0000-000000000000', name: 'Jonas Backman' },
        { id: '00B0397A-0000-0000-0000-000000000000', name: 'Kalle Hultman' },
        { id: '00ACB5AA-0000-0000-0000-000000000000', name: 'Karl Altenstam' },
        { id: '00ACC2F4-0000-0000-0000-000000000000', name: 'Mirza Kozica' },
        { id: '00ACB9A6-0000-0000-0000-000000000000', name: 'Paula Wallner' },
        { id: '00B64414-0000-0000-0000-000000000000', name: 'Rebecca Nilsson' },
        { id: '00B64417-0000-0000-0000-000000000000', name: 'Sofia Rosqvist' },
    ],
};

const sthlm_private_kam = {
    id: 'sthlm_private_kam',
    name: 'STHLM - Private KAM',
    users: [
        { id: '00ACB5FC-0000-0000-0000-000000000000', name: 'Jacob Rudin' },
        { id: '00AE5708-0000-0000-0000-000000000000', name: 'Johanna Torstensson' },
        { id: '00B64414-0000-0000-0000-000000000000', name: 'Rebecca Nilsson' },
        { id: '00B64417-0000-0000-0000-000000000000', name: 'Sofia Rosqvist' },
    ],
};

const sthlm_public = {
    id: 'sthlm_public',
    name: 'STHLM - Public',
    users: [
        { id: '00AAB501-0000-0000-0000-000000000000', name: 'Daniel Henriksson' },
        { id: '00AAB50C-0000-0000-0000-000000000000', name: 'Hanna Werner' },
        { id: '00AE570A-0000-0000-0000-000000000000', name: 'Klara Hellman' },
        { id: '00ACB652-0000-0000-0000-000000000000', name: 'Madeléne Gardbeck' },
        { id: '00ACB732-0000-0000-0000-000000000000', name: 'Mattias Danielsson' },
        { id: '00ACB712-0000-0000-0000-000000000000', name: 'Simon Jansson' },
        { id: '00C12436-0000-0000-0000-000000000000', name: 'Thomas Sundtoft' },
        { id: '00CABCE8-0000-0000-0000-000000000000', name: 'Julia Wolf' },
        { id: '00D03F24-0000-0000-0000-000000000000', name: 'Victor Sá' },
        { id: '00D03F3A-0000-0000-0000-000000000000', name: 'Joakim Larsson' },
    ],
};

const sthlm_team_mirza = {
    id: 'sthlm_team_mirza',
    name: 'STHLM - Team Mirza',
    users: [
        { id: '00B6441A-0000-0000-0000-000000000000', name: 'Camjar Djoweini' },
        { id: '00B1BDC8-0000-0000-0000-000000000000', name: 'Gustaf Lindell' },
        { id: '00ACCEBC-0000-0000-0000-000000000000', name: 'Jonas Backman' },
        { id: '00B0397A-0000-0000-0000-000000000000', name: 'Kalle Hultman' },
        { id: '00ACC2F4-0000-0000-0000-000000000000', name: 'Mirza Kozica' },
        { id: '00ACB9A6-0000-0000-0000-000000000000', name: 'Paula Wallner' },
        { id: '00B81BA1-0000-0000-0000-000000000000', name: 'Anders Camper' },
        { id: '00C9EA3B-0000-0000-0000-000000000000', name: 'Jesper Lundström' },
    ],
};

const syd = {
    id: 'syd',
    name: 'SYD',
    users: [
        { id: '00AD7652-0000-0000-0000-000000000000', name: 'Cajsa Andersson' },
        { id: '00ACAD84-0000-0000-0000-000000000000', name: 'Christian Rydström' },
        { id: '00ADAAEE-0000-0000-0000-000000000000', name: 'Elisabeth Paulsson' },
        { id: '00AD764A-0000-0000-0000-000000000000', name: 'Emil Sjöqvist' },
        { id: '00AD7650-0000-0000-0000-000000000000', name: 'Erik Altenstam' },
        { id: '00ADAAEC-0000-0000-0000-000000000000', name: 'Orhan Arnautovic' },
        { id: '00BA3AAA-0000-0000-0000-000000000000', name: 'Pierre Karlsson' },
        { id: '00C4379D-0000-0000-0000-000000000000', name: 'Stephanie Schramm Davholt' },
        { id: '00C437B3-0000-0000-0000-000000000000', name: 'Evelina Palm' },
        { id: '00D0E542-0000-0000-0000-000000000000', name: 'Fabian Hägglöf' },
        { id: '00D62828-0000-0000-0000-000000000000', name: 'Mye Senekovic' },
        { id: '00D62833-0000-0000-0000-000000000000', name: 'Herman Svensson' },
    ],
};

const uppsala = {
    id: 'uppsala',
    name: 'UPPSALA',
    users: [
        { id: '00ACCEBC-0000-0000-0000-000000000000', name: 'Jonas Backman' },
        { id: '00C12436-0000-0000-0000-000000000000', name: 'Thomas Sundtoft' },
        { id: '00D03F24-0000-0000-0000-000000000000', name: 'Victor Sá' },
    ],
};

const vast = {
    id: 'vast',
    name: 'VÄST',
    users: [
        { id: '00AD509E-0000-0000-0000-000000000000', name: 'Alexander Björk' },
        { id: '00AD50A0-0000-0000-0000-000000000000', name: 'Biken Lam' },
        { id: '00ACAD8A-0000-0000-0000-000000000000', name: 'Carl Hagberg' },
        { id: '00AD50A2-0000-0000-0000-000000000000', name: 'Christoffer Thiel' },
        { id: '00AD5098-0000-0000-0000-000000000000', name: 'Daniel Svärdskog' },
        { id: '00B106FA-0000-0000-0000-000000000000', name: 'Patrick Person' },
        { id: '00AD50AE-0000-0000-0000-000000000000', name: 'Pär Svensén' },
        { id: '00B7137D-0000-0000-0000-000000000000', name: 'Zuhal Feizi' },
        { id: '00C2072C-0000-0000-0000-000000000000', name: 'Hampus Lundqvist' },
        { id: '00C20737-0000-0000-0000-000000000000', name: 'Benjamin Andersson' },
        { id: '00C7DA25-0000-0000-0000-000000000000', name: 'Felix Arvidsson' },
        { id: '00C7DA30-0000-0000-0000-000000000000', name: 'Gina Mori' },
        { id: '00CDAC21-0000-0000-0000-000000000000', name: 'Gustaf Hörnell' },
        { id: '00D0E537-0000-0000-0000-000000000000', name: 'Erik Andersson' },
        { id: '00D0E818-0000-0000-0000-000000000000', name: 'Simon Svärdh' },
    ],
};

const vaxjo_varnamo_kalmar = {
    id: 'vaxjo_varnamo_kalmar',
    name: 'VÄXJÖ/VÄRNAMO/KALMAR',
    users: [
        { id: '00A3F646-0000-0000-0000-000000000000', name: 'Louise Ohlin' },
        { id: '00A44A93-0000-0000-0000-000000000000', name: 'Sebastian Schrewelius' },
    ],
};

// Added oslo, not sure if relevant yet but dont export it in teams and its fine
const oslo = {
    id: 'oslo',
    name: "Oslo",
    users: [
        { id: '000CF5DC5-0000-0000-0000-000000000000', name: 'Fabian Alexander Ottho'},
        { id: '000D3EE64-0000-0000-0000-000000000000', name: 'André Aamelfot'}
    ],
}

export const teams = [
    boras,
    gavle,
    jkpg,
    karlskrona,
    mitt,
    mitt_new_business,
    sthlm,
    sthlm_private,
    sthlm_private_kam,
    sthlm_public,
    sthlm_team_mirza,
    syd,
    uppsala,
    vast,
    vaxjo_varnamo_kalmar,
];
